import {getCookie} from "@weseus/cms-core/assets/js/helpers";

export default class GDPRSettingsStorage {

	cookieName = 'eu-cookies';

	constructor(options = {}) {
		let metaOptionsElement = document.getElementById('fn_consent_storage_options');
		if (metaOptionsElement !== null) {
			options = Object.assign(
				options, JSON.parse(metaOptionsElement.getAttribute('data-options')));
		}

		if (options.cookieName !== undefined) {
			this.cookieName = options.cookieName;
		}
	}

	/**
	 * Save user's GDPR settings
	 *
	 * @param settings
	 */
	save(settings) {
		const date = new Date();
		date.setFullYear(date.getFullYear() + 10);

		settings = this._fixMarketing(settings);

		const value = settings.length > 0 ? settings.join(',') : '-';

		document.cookie = this.cookieName + '=' + value + '; path=/; expires=' + date.toGMTString();
	}

	// Změna z jedné marketing consent na try, změněno se zpětnou kompabilitou
	_fixMarketing(settings) {
		if (settings.includes('marketing')) {

			// Najdi index 'marketing' v poli
			let index = settings.indexOf('marketing');

			// Odstran 'marketing' z pole
			settings.splice(index, 1);

			// Vlož nové položky na místo 'marketing'
			settings.splice(index, 0, 'adStorage', 'adUserData', 'adPersonalization');
		}

		return settings;
	}

	/**
	 * Load user's GDPR settings
	 *
	 * @return {Array}
	 */
	load() {
		const data = getCookie(this.cookieName);

		if (data === null || data === '' || data === '1' || data === '-') {
			return [];
		}

		let items =  data.split(',')

		items = this._fixMarketing(items);

		return items
	}

	/**
	 * Clear user's GDPR settings
	 */
	clear() {
		let date = new Date();
		date.setFullYear(date.getFullYear() - 1);

		document.cookie = this.cookieName + '=; path=/; expires=' + date.toGMTString();
	}

	/**
	 * Has user's GDPR settings
	 *
	 * @return {boolean}
	 */
	has() {
		const data = getCookie(this.cookieName);
		return data !== null && data !== '' && data !== '1';
	}

}